import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntCalendarActionCellComponent} from "./int-calendar-action-cell.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntCalendarActionCellComponent
  ],
  exports: [
    IntCalendarActionCellComponent
  ]
})
export class IntCalendarActionCellModule {}
